import FORM_CONFIG from './config'
import FORM_ADVANCE_CONFIG from './advance'

export default {
  FORM_CONFIG,
  FORM_ADVANCE_CONFIG,
}
